import { render, staticRenderFns } from "./ScheduledNotificationSkeleton.vue?vue&type=template&id=0d55105c&"
import script from "./ScheduledNotificationSkeleton.vue?vue&type=script&lang=js&"
export * from "./ScheduledNotificationSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
